import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { Action } from '../../actions';
import { phrasesSelectorRefinePopupOpenMetrica } from '../../actions/phrases-selector';
import {
    phrasesSelectorClearKeywords,
    phrasesSelectorRefineKeyword,
    phrasesSelectorRemoveKeyword
} from '../../actions/phrases-selector/persistentData';
import {
    PhrasesSelectorKeywords,
    PhrasesSelectorKeywordsProps
} from '../../components/PhrasesSelector/PhrasesSelectorKeywords/PhrasesSelectorKeywords';
import { selectPhrasesSelectorData } from '../../selectors/phrasesSelector/phrasesSelector';
import { GroupId } from '../../typings/groups';
import { PhrasesSelectorPhrase, PhrasesSelectorWizardId } from '../../typings/phrases';
import { State } from '../../typings/state';
import { TDispatchProps, TStateProps } from '../../typings/utils';

export interface OwnProps {
    groupId: GroupId;
    wizardId: PhrasesSelectorWizardId;
}

type StateProps = TStateProps<PhrasesSelectorKeywordsProps, OwnProps>;
type DispatchProps = TDispatchProps<PhrasesSelectorKeywordsProps, OwnProps>;

const mapStateToProps = (state: State, ownProps: OwnProps): StateProps => {
    const { wizardId } = ownProps;
    const [, { keywords }] = selectPhrasesSelectorData(state, wizardId);

    return {
        keywords
    };
};

const mapDispatchToProps = (dispatch: Dispatch<Action>, ownProps: OwnProps): DispatchProps => {
    const { wizardId, groupId } = ownProps;

    return {
        onRemove(index: number) {
            dispatch(phrasesSelectorRemoveKeyword(groupId, index));
        },
        onRefine(index: number, phrase: PhrasesSelectorPhrase) {
            dispatch(phrasesSelectorRefineKeyword(groupId, index, phrase));
        },
        onRefinePopupOpenMetrica() {
            dispatch(phrasesSelectorRefinePopupOpenMetrica(wizardId));
        },
        onKeywordsClear() {
            dispatch(phrasesSelectorClearKeywords(groupId, wizardId));
        }
    };
};

const mergeProps = (
    stateProps: StateProps,
    dispatchProps: DispatchProps,
    ownProps: OwnProps
): PhrasesSelectorKeywordsProps => {
    return {
        ...stateProps,
        ...dispatchProps,
        ...ownProps
    };
};

export const PhrasesSelectorKeywordsContainer = connect<
    StateProps,
    DispatchProps,
    OwnProps,
    PhrasesSelectorKeywordsProps
>(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
)(PhrasesSelectorKeywords);
